module.exports = __webpack_public_path__ + "static/media/8-rectangle-onhold.62a091ae.svg";